import { HttpService } from '@/services/http.service';

export default {
    async store(employeeTrainingVideoAnalytic) {
        return await HttpService.httpPost(`/employee-training-video-analytics`, employeeTrainingVideoAnalytic);
    },
}
